import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=5ec3f8f1&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"
import style0 from "./Edit.vue?vue&type=style&index=0&id=5ec3f8f1&prod&lang=scss&scoped=true"
import style1 from "./Edit.vue?vue&type=style&index=1&id=5ec3f8f1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec3f8f1",
  null
  
)

export default component.exports